(() => {
  const init = root => root.querySelectorAll('.dut-blog-more').forEach(control => {
    if (control.dataset.ready) return;
    control.dataset.ready = 'true';
    const link = control.querySelector('a');
    if (!link) return;
    const grid = control.closest('.dut-blog').querySelector('.blog-articles');
    let busy = false;
    link.addEventListener('click', async event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (busy) return;
      busy = true;
      link.textContent = 'Loading…';
      link.setAttribute('aria-disabled', 'true');
      grid.setAttribute('aria-busy', 'true');
      control.querySelector('[role="alert"]').hidden = true;
      try {
        const response = await fetch(link.href);
        if (!response.ok) throw new Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextControl = doc.querySelector('.dut-blog-more');
        const cards = [...doc.querySelectorAll('.dut-blog .blog-articles > .article')];
        if (!nextControl || !cards.length) throw new Error('Missing posts');
        cards.forEach(card => { card.classList.remove('scroll-trigger', 'animate--slide-in'); });
        grid.append(...cards);
        const count = nextControl.querySelector('[data-viewed]').textContent;
        control.querySelector('[data-viewed]').textContent = count;
        control.querySelector('progress').value = Number(count);
        const next = nextControl.querySelector('a');
        if (next) link.href = next.getAttribute('href');
        else link.hidden = true;
        const firstLink = cards[0].querySelector('h2 a');
        firstLink.focus({ preventScroll: true });
      } catch {
        control.querySelector('[role="alert"]').hidden = false;
      } finally {
        busy = false;
        link.textContent = 'Load More';
        link.removeAttribute('aria-disabled');
        grid.removeAttribute('aria-busy');
      }
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
